$(document).ready(function () {
  let p = $('body').attr('p');
  let locationId = $('body').attr('event_id');
  let selectedTemplate;
  if (p === 'template_import') {
    $(document).on('change', '#template-selector', function () {
      $('#imported-data-tables').empty();
      selectedTemplate = $(this).val();

      $('.template-group-container').attr('hidden', true).removeClass('d-flex');

      if (selectedTemplate === 'product-group-template') {
        $('#product-group-template-import').attr('hidden', false);
        $('#product-group-template-import').addClass('d-flex');
      }
      if (selectedTemplate === 'product-template') {
        $('#product-template-import').attr('hidden', false);
        $('#product-template-import').addClass('d-flex');
      }
      if (selectedTemplate === 'supplier-template') {
        $('#supplier-template-import').attr('hidden', false);
        $('#supplier-template-import').addClass('d-flex');
      }
      if (selectedTemplate === 'private-customer-template') {
        $('#private-customer-template-import').attr('hidden', false);
        $('#private-customer-template-import').addClass('d-flex');
      }
      if (selectedTemplate === 'company-customer-template') {
        $('#company-customer-template-import').attr('hidden', false);
        $('#company-customer-template-import').addClass('d-flex');
      }
    });

    $(document).on('click', '#parentToggle', function () {
      const $parent = $('#parentCollapse');
      const $childWrapper = $('#childWrapper');
      const $parentArrow = $('#parentToggle .arrow-icon');

      // Toggle parent collapse
      $parent.collapse('toggle');

      // Show children and open all child collapses when parent is shown
      $parent.on('shown.bs.collapse', function () {
        $parentArrow.addClass('open');
        $childWrapper.removeClass('d-none');

        // Open all child collapses
        $('[id^="childCollapse-"]').each(function () {
          const $childCollapse = $(this);
          if (!$childCollapse.hasClass('show')) {
            $childCollapse.collapse('show');
          }
        });

        // Rotate all child arrows (assuming .arrow-icon is inside the toggle div)
        $(
          '[data-toggle="collapse"][data-target^="#childCollapse-"] .arrow-icon'
        ).addClass('open');
      });

      // Hide children and collapse all child collapses when parent is hidden
      $parent.on('hidden.bs.collapse', function () {
        $parentArrow.removeClass('open');
        $childWrapper.addClass('d-none');
        // Optionally close all child collapses
        $('[id^="childCollapse-"]').each(function () {
          const $childCollapse = $(this);
          if ($childCollapse.hasClass('show')) {
            $childCollapse.collapse('hide');
          }
        });

        // Reset arrow icons
        $(
          '[data-toggle="collapse"][data-target^="#childCollapse-"] .arrow-icon'
        ).removeClass('open');
      });
    });
  }
});

function setImportLoadingState(isLoading, label) {
  if (isLoading) {
    $('#importSpinner').removeClass('d-none');
    $('#importLoadingMessage').removeClass('d-none');
    $('#importing-label').text(label);
  } else {
    $('#importSpinner').addClass('d-none');
    $('#importLoadingMessage').addClass('d-none');
    $('#importing-label').text('');
  }
}
